export const MaingeneralContracting = {
    "imageUrl": "/assets/imgs/services/7generalContracting/fondo.png",
    "eyebrow": "General",
    "title": "Contracting",
    "headingSpan": "COMPREHENSIVE SOLUTIONS",
    "heading": "FOR YOUR BUILDING NEEDS",
    "description": "At HRD Painting & Restoration, we offer full-service general contracting solutions tailored to the unique needs of commercial, industrial, and multi-unit residential properties. Whether you're planning a large-scale renovation, structural repairs, or tenant improvements, our skilled team ensures seamless project execution, high-quality craftsmanship, and on-time delivery.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};